import {
  showNotification,
  NotificationType,
} from 'store/notifications/NotificationsSlice';

import { store } from 'index';
import messages from 'components/ErrorView/Message';

const notify = (
  message: string,
  type: NotificationType = 'successful',
  autoClose: boolean = true,
  timeToHide: number = 3000
) => {
  return store.dispatch(
    showNotification({ type, message, autoClose, timeToHide })
  );
};
export const notifyError = (
  errorObj: any,
  autoClose: boolean = true,
  timeToHide: number = 3000
) => {
  console.trace(errorObj?.stack);
  return store.dispatch(
    showNotification({
      type: 'error',
      message:
        messages[errorObj?.data?.message] ||
        errorObj?.data?.message ||
        messages.unknownError,
      autoClose,
      timeToHide,
    })
  );
};

export default notify;
